jQuery(document).ready(function ($) {
  let SelectedFigure;

  function getHighestResImg(srcset) {
    return srcset.split(",").reduce(
      (acc, item) => {
        let [url, width] = item.trim().split(" ");
        width = parseInt(width);
        if (width > acc.width) return { width, url };
        return acc;
      },
      { width: 0, url: "" }
    ).url;
  }

  $(".wp-block-gallery.has-nested-images .wp-block-image").on(
    "click",
    function () {
      SelectedFigure = $(this);

      let imageSrc = $(this).find("img").attr("srcset");

      imageSrc = getHighestResImg(imageSrc);

      let popupItem = $(
        `<div class="block-gallery-popup">
          <div class="block-gallery-popup-inner">
          <span class="block-gallery-popup-inner-close block-gallery-close hidden-xs">╳</span>
            <div class="block-gallery-popup-inner-container">
              <span class="block-gallery-popup-inner-container-close block-gallery-close visible-xs-block">╳</span>
              <div class="prev block-gallery-prev hidden-xs"><span><img src="${window.location.origin}/wp-content/themes/ThisIs/src/assets/images/svg/ico-right-arrow.svg"></span></div>
              <img src="${imageSrc}" id="block-gallery-popup-image">
              <div class="next block-gallery-next hidden-xs"><span><img src="${window.location.origin}/wp-content/themes/ThisIs/src/assets/images/svg/ico-right-arrow.svg"></span></div>
              <div class="block-gallery-popup-inner-container-mobile_navigation visible-xs-flex">
                <div class="prev block-gallery-prev"><span><img src="${window.location.origin}/wp-content/themes/ThisIs/src/assets/images/svg/ico-right-arrow.svg"></span></div>
                <div class="next block-gallery-next"><span><img src="${window.location.origin}/wp-content/themes/ThisIs/src/assets/images/svg/ico-right-arrow.svg"></span></div>
              </div>
            </div>
          </div>
        </div>`
      );

      $("body").append(popupItem);

      if (!$(SelectedFigure).next(".wp-block-image").length) {
        $(".block-gallery-next")
          .css("opacity", "0.5")
          .css("ponter-events", "none");
      } else {
        $(".block-gallery-next")
          .css("opacity", "1")
          .css("ponter-events", "all");
      }
      if (!$(SelectedFigure).prev(".wp-block-image").length) {
        $(".block-gallery-prev")
          .css("opacity", "0.5")
          .css("ponter-events", "none");
      } else {
        $(".block-gallery-prev")
          .css("opacity", "1")
          .css("ponter-events", "all");
      }
    }
  );

  $(document).on("click", ".block-gallery-close", function () {
    $(".block-gallery-popup").remove();
    SelectedFigure = null;
  });

  $(document).on("click", ".block-gallery-next span", function () {
    if ($(SelectedFigure).next(".wp-block-image").length) {
      SelectedFigure = $(SelectedFigure).next(".wp-block-image");

      let imageSrc = $(SelectedFigure).find("img").attr("srcset");
      imageSrc = getHighestResImg(imageSrc);

      if (!imageSrc) {
        imageSrc = $(SelectedFigure).find("img").attr("src");
      }

      $("#block-gallery-popup-image").attr("src", imageSrc);
    }

    if (!$(SelectedFigure).next(".wp-block-image").length) {
      $(".block-gallery-next")
        .css("opacity", "0.5")
        .css("ponter-events", "none");
    } else {
      $(".block-gallery-next").css("opacity", "1").css("ponter-events", "all");
    }
    if (!$(SelectedFigure).prev(".wp-block-image").length) {
      $(".block-gallery-prev")
        .css("opacity", "0.5")
        .css("ponter-events", "none");
    } else {
      $(".block-gallery-prev").css("opacity", "1").css("ponter-events", "all");
    }
  });

  $(document).on("click", ".block-gallery-prev span", function () {
    if ($(SelectedFigure).prev(".wp-block-image").length) {
      SelectedFigure = $(SelectedFigure).prev(".wp-block-image");

      let imageSrc = $(SelectedFigure).find("img").attr("srcset");
      imageSrc = getHighestResImg(imageSrc);

      if (!imageSrc) {
        imageSrc = $(SelectedFigure).find("img").attr("src");
      }

      $("#block-gallery-popup-image").attr("src", imageSrc);
    }

    if (!$(SelectedFigure).next(".wp-block-image").length) {
      $(".block-gallery-next")
        .css("opacity", "0.5")
        .css("ponter-events", "none");
    } else {
      $(".block-gallery-next").css("opacity", "1").css("ponter-events", "all");
    }
    if (!$(SelectedFigure).prev(".wp-block-image").length) {
      $(".block-gallery-prev")
        .css("opacity", "0.5")
        .css("ponter-events", "none");
    } else {
      $(".block-gallery-prev").css("opacity", "1").css("ponter-events", "all");
    }
  });
});
